import React from 'react';

const SarError = () => {
  return (
    <main
      className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
      id="content"
      role="main"
      tabIndex={0}
    >
      <h1 data-test="error-header">
        Sorry, there is a problem with the service
      </h1>
      <p data-test="error-text-1">Try again later.</p>
      <p data-test="error-text-2">
        Contact the{' '}
        <a href="mailto:ChemicalReportingTeam@homeoffice.gov.uk">
          Chemical Reporting Team
        </a>{' '}
        if you require further support. The inbox is monitored by the team
        Monday to Friday 9am to 5pm. It is not monitored on bank holidays.
      </p>
    </main>
  );
};
export default SarError;
